module.exports = __webpack_public_path__ + "img/cp2077.d016a32e.png";